import DonationRequests from "../../DonationRequests/DonationRequests"


const Donations = () => {
  return (
    <div>
      <DonationRequests/>
    </div>
  )
}

export default Donations
